import { Table } from 'antd';
import moment from 'moment';
import { TransactionEntity } from '../../../../../entities/transaction.entity';
import { formatNum } from '../../../../../shared/constants';
import { StatusPill } from '../../../shared/StatusPill';

export const TransactionFinalise = ({
  onSelect,
  transactions,
}: {
  onSelect?: (transaction: TransactionEntity) => void;
  transactions: TransactionEntity[];
}) => {
  const COLUMNS = [
    {
      title: 'Intervenants',
      width: 260,
      render: (_cell: any, row: any) => (
        <div className='party-cell'>
          <strong>{row.assetManager?.code_referent || '--'} - {row.assetManager?.nom || '--'}</strong>
          <span>{row.partenaire?.code_referent || '--'} - {row.partenaire?.nom || '--'}</span>
        </div>
      ),
    },
    {
      title: 'Titre',
      width: 190,
      render: (_cell: any, row: TransactionEntity) => (
        <div className='security-cell'>
          <strong>{row.titre?.code || '--'}</strong>
          <span>{row.titre?.pays || '--'} · {row.titre?.instrument || '--'}</span>
        </div>
      ),
    },
    {
      title: 'Code transaction',
      dataIndex: 'code',
    },
    {
      title: 'Détenteur',
      width: 220,
      render: (_cell: any, row: TransactionEntity) => (
        <div className='party-cell'>
          <strong>{row.detenteur?.code_referent || '--'} - {row.detenteur?.nom || '--'}</strong>
          <span>{row.detenteur?.prenom || '--'}</span>
        </div>
      ),
    },
    {
      title: 'Agence / Gestionnaire',
      render: (_cell: any, row: any) => (
        <div className='party-cell'>
          <strong>{row.agence?.code || '--'} - {row.agence?.nom || '--'}</strong>
          <span>{row.utilisateur?.nom || '--'} {row.utilisateur?.prenom || ''}</span>
        </div>
      ),
    },
    {
      title: 'Opération',
      dataIndex: 'typeOperation',
      render: (cell: any) => (
        <span className={`operation-chip ${cell === 'VENTE' ? 'sell' : 'buy'}`}>
          {cell || '--'}
        </span>
      ),
    },
    {
      title: 'Date Opération',
      dataIndex: 'created_at',
      render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
    },
    {
      title: 'Date Finalisation',
      dataIndex: 'updated_at',
      render: (cell: any) => `${moment(cell).format('DD/MM/YYYY')}`,
    },
    {
      title: 'Statut',
      dataIndex: 'statut',
      render: (cell: any) => (
        <StatusPill tone={cell === 'finalisé' ? 'success' : 'warning'}>
          {cell === 'finalisé' ? 'Finalisé' : 'En cours'}
        </StatusPill>
      ),
    },
    {
      title: 'Qte',
      dataIndex: 'qte',
      render: (cell: any) => <span className='amount-cell'>{formatNum(cell) || '--'}</span>,
      align: 'right' as const,
    },
    {
      title: 'Coupon',
      dataIndex: 'tauxInteret',
    },
    {
      title: 'Décote',
      dataIndex: 'decote',
    },
    {
      title: 'Rendement',
      dataIndex: 'tauxRendement',
    },
    {
      title: 'Prix',
      render: (_cell: any, row: TransactionEntity) => (
        <span className='amount-cell'>{formatNum(row.prixNominale * 1) || '--'}</span>
      ),
      align: 'right' as const,
    },
    {
      title: 'Montant restant',
      render: (_cell: any, row: TransactionEntity) => (
        <span className='amount-cell'>{formatNum(row.qte * row.prixNominale) || '--'}</span>
      ),
      align: 'right' as const,
    },
    {
      title: 'Commission',
      render: (_cell: any, row: TransactionEntity) => (
        <span className='amount-cell'>{formatNum(
          Math.ceil(
            Number(row.commIntermediation) +
              Number(row.commConservation) +
              Number(row.commDroitGarde) +
              Number(row.commBrokerage),
          ),
        ) || '--'}</span>
      ),
      align: 'right' as const,
    },
    {
      title: 'Net à payer',
      render: (_cell: any, row: TransactionEntity) => (
        <span className='amount-cell buy-text'>{formatNum(
          Math.ceil(
            Number(row.qte) * Number(row.prixNominale) +
              Number(row.couponCouruPayer) +
              Number(row.commIntermediation) +
              Number(row.commConservation) +
              Number(row.commDroitGarde) +
              Number(row.commBrokerage),
          ),
        ) || '--'}</span>
      ),
      align: 'right' as const,
    },
  ];

  return (
    <div>
      <Table
        columns={COLUMNS}
        dataSource={transactions}
        rowKey='id'
        rowClassName={(row, index) =>
          index % 2 === 0 ? 'even-row' : 'odd-row'
        }
        className='reporting-table'
        size='small'
        pagination={{
          defaultPageSize: 20,
          position: ['bottomRight'],
        }}
        scroll={{ x: 'max-content' }}
        onRow={(row) => ({
          onClick: () => onSelect?.(row),
        })}
      />
    </div>
  );
};
